"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AddGreenIcon_1 = __importDefault(require("./AddGreenIcon"));
const AddIcon_1 = __importDefault(require("./AddIcon"));
const AddMoreIcon_1 = __importDefault(require("./AddMoreIcon"));
const AlertSuccessIcon_1 = __importDefault(require("./AlertSuccessIcon"));
const ArrowLeftIcon_1 = __importDefault(require("./ArrowLeftIcon"));
const ArrowRightIcon_1 = __importDefault(require("./ArrowRightIcon"));
const BoxBubbleIcon_1 = __importDefault(require("./BoxBubbleIcon"));
const BoxIcon_1 = __importDefault(require("./BoxIcon"));
const CalendarIcon_1 = __importDefault(require("./CalendarIcon"));
const CameraIcon_1 = __importDefault(require("./CameraIcon"));
const CancelBubbleIcon_1 = __importDefault(require("./CancelBubbleIcon"));
const CancelIcon_1 = __importDefault(require("./CancelIcon"));
const CarIcon_1 = __importDefault(require("./CarIcon"));
const CategoryCreditCardIcon_1 = __importDefault(require("./CategoryCreditCardIcon"));
const CategoryFragileIcon_1 = __importDefault(require("./CategoryFragileIcon"));
const CategoryHouseIcon_1 = __importDefault(require("./CategoryHouseIcon"));
const CategoryLiftIcon_1 = __importDefault(require("./CategoryLiftIcon"));
const CategoryPeopleIcon_1 = __importDefault(require("./CategoryPeopleIcon"));
const CategoryWeightIcon_1 = __importDefault(require("./CategoryWeightIcon"));
const CheckIcon_1 = __importDefault(require("./CheckIcon"));
const ChevronDownIcon_1 = __importDefault(require("./ChevronDownIcon"));
const ChevronLeftIcon_1 = __importDefault(require("./ChevronLeftIcon"));
const ChevronRightIcon_1 = __importDefault(require("./ChevronRightIcon"));
const ChevronUpIcon_1 = __importDefault(require("./ChevronUpIcon"));
const ClockIcon_1 = __importDefault(require("./ClockIcon"));
const CoinIcon_1 = __importDefault(require("./CoinIcon"));
const CommentIcon_1 = __importDefault(require("./CommentIcon"));
const CsvIcon_1 = __importDefault(require("./CsvIcon"));
const DocumentIcon_1 = __importDefault(require("./DocumentIcon"));
const DownloadIcon_1 = __importDefault(require("./DownloadIcon"));
const DriverIcon_1 = __importDefault(require("./DriverIcon"));
const EditIcon_1 = __importDefault(require("./EditIcon"));
const EmailIcon_1 = __importDefault(require("./EmailIcon"));
const ErrorIcon_1 = __importDefault(require("./ErrorIcon"));
const FacebookIcon_1 = __importDefault(require("./FacebookIcon"));
const FilterIcon_1 = __importDefault(require("./FilterIcon"));
const GalleryIcon_1 = __importDefault(require("./GalleryIcon"));
const GarbageIcon_1 = __importDefault(require("./GarbageIcon"));
const GoogleIcon_1 = __importDefault(require("./GoogleIcon"));
const HamburgerMenuIcon_1 = __importDefault(require("./HamburgerMenuIcon"));
const HelpIcon_1 = __importDefault(require("./HelpIcon"));
const HideIcon_1 = __importDefault(require("./HideIcon"));
const HomeGreenIcon_1 = __importDefault(require("./HomeGreenIcon"));
const HomeIcon_1 = __importDefault(require("./HomeIcon"));
const InformationIcon_1 = __importDefault(require("./InformationIcon"));
const InstagramIcon_1 = __importDefault(require("./InstagramIcon"));
const IntegrationIcon_1 = __importDefault(require("./IntegrationIcon"));
const InvoiceIcon_1 = __importDefault(require("./InvoiceIcon"));
const LiftIcon_1 = __importDefault(require("./LiftIcon"));
const LinkedInIcon_1 = __importDefault(require("./LinkedInIcon"));
const LocationIcon_1 = __importDefault(require("./LocationIcon"));
const LocationWhiteBgIcon_1 = __importDefault(require("./LocationWhiteBgIcon"));
const LockIcon_1 = __importDefault(require("./LockIcon"));
const LogoutIcon_1 = __importDefault(require("./LogoutIcon"));
const MeasureIcon_1 = __importDefault(require("./MeasureIcon"));
const MissedRedIcon_1 = __importDefault(require("./MissedRedIcon"));
const MixIcon_1 = __importDefault(require("./MixIcon"));
const MoreIcon_1 = __importDefault(require("./MoreIcon"));
const NotificationIcon_1 = __importDefault(require("./NotificationIcon"));
const OrganizeIcon_1 = __importDefault(require("./OrganizeIcon"));
const PalletIcon_1 = __importDefault(require("./PalletIcon"));
const PdfIcon_1 = __importDefault(require("./PdfIcon"));
const PeopleIcon_1 = __importDefault(require("./PeopleIcon"));
const PhoneIcon_1 = __importDefault(require("./PhoneIcon"));
const PreferencesIcon_1 = __importDefault(require("./PreferencesIcon"));
const RouteIcon_1 = __importDefault(require("./RouteIcon"));
const SearchIcon_1 = __importDefault(require("./SearchIcon"));
const ShowIcon_1 = __importDefault(require("./ShowIcon"));
const SofaIcon_1 = __importDefault(require("./SofaIcon"));
const StatusActiveIcon_1 = __importDefault(require("./StatusActiveIcon"));
const StatusDefaultIcon_1 = __importDefault(require("./StatusDefaultIcon"));
const StatusMissedIcon_1 = __importDefault(require("./StatusMissedIcon"));
const StatusSuccessIcon_1 = __importDefault(require("./StatusSuccessIcon"));
const SuitcaseIcon_1 = __importDefault(require("./SuitcaseIcon"));
const TelephelyIcon_1 = __importDefault(require("./TelephelyIcon"));
const TemplateIcon_1 = __importDefault(require("./TemplateIcon"));
const TikTokIcon_1 = __importDefault(require("./TikTokIcon"));
const TruckBubbleIcon_1 = __importDefault(require("./TruckBubbleIcon"));
const TruckGreenIcon_1 = __importDefault(require("./TruckGreenIcon"));
const TruckIcon_1 = __importDefault(require("./TruckIcon"));
const UploadIcon_1 = __importDefault(require("./UploadIcon"));
const UserIcon_1 = __importDefault(require("./UserIcon"));
const WebIcon_1 = __importDefault(require("./WebIcon"));
const WeightIcon_1 = __importDefault(require("./WeightIcon"));
const YoutubeIcon_1 = __importDefault(require("./YoutubeIcon"));
const IconType_1 = __importDefault(require("../enums/IconType"));
const DefaultIcon = (props) => {
    // if (props.type === IconType.None) {
    //     return <></>;
    // } else {
    //     var CustomTag = [props.type + "Icon"];
    //     console.log(CustomTag);
    //     // return <CustomTag color={`icn-${props.color}`} size={`icn-${props.size}`}></CustomTag>;
    //     const color = "icn-" + props.color;
    //     const size = "icn-" + props.size;
    //     return React.createElement(
    //         CustomTag,
    //         {
    //             color: color,
    //             size: size,
    //         },
    //         null
    //     );
    // }
    switch (props.type) {
        case IconType_1.default.None:
            return react_1.default.createElement(react_1.default.Fragment, null);
        case IconType_1.default.AddGreen:
            return react_1.default.createElement(AddGreenIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Add:
            return react_1.default.createElement(AddIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.AddMore:
            return react_1.default.createElement(AddMoreIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.AlertSuccess:
            return react_1.default.createElement(AlertSuccessIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.ArrowLeft:
            return react_1.default.createElement(ArrowLeftIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.ArrowRight:
            return react_1.default.createElement(ArrowRightIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.BoxBubble:
            return react_1.default.createElement(BoxBubbleIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Box:
            return react_1.default.createElement(BoxIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Calendar:
            return react_1.default.createElement(CalendarIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Camera:
            return react_1.default.createElement(CameraIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.CancelBubble:
            return react_1.default.createElement(CancelBubbleIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Cancel:
            return react_1.default.createElement(CancelIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Car:
            return react_1.default.createElement(CarIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.CategoryCreditCard:
            return react_1.default.createElement(CategoryCreditCardIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.CategoryFragile:
            return react_1.default.createElement(CategoryFragileIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.CategoryHouse:
            return react_1.default.createElement(CategoryHouseIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.CategoryLift:
            return react_1.default.createElement(CategoryLiftIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.CategoryPeople:
            return react_1.default.createElement(CategoryPeopleIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.CategoryWeight:
            return react_1.default.createElement(CategoryWeightIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Check:
            return react_1.default.createElement(CheckIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.ChevronDown:
            return react_1.default.createElement(ChevronDownIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.ChevronLeft:
            return react_1.default.createElement(ChevronLeftIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.ChevronRight:
            return react_1.default.createElement(ChevronRightIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.ChevronUp:
            return react_1.default.createElement(ChevronUpIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Clock:
            return react_1.default.createElement(ClockIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Coin:
            return react_1.default.createElement(CoinIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Comment:
            return react_1.default.createElement(CommentIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Csv:
            return react_1.default.createElement(CsvIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Document:
            return react_1.default.createElement(DocumentIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Download:
            return react_1.default.createElement(DownloadIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Driver:
            return react_1.default.createElement(DriverIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Edit:
            return react_1.default.createElement(EditIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Email:
            return react_1.default.createElement(EmailIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Facebook:
            return react_1.default.createElement(FacebookIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Error:
            return react_1.default.createElement(ErrorIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Filter:
            return react_1.default.createElement(FilterIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Gallery:
            return react_1.default.createElement(GalleryIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Garbage:
            return react_1.default.createElement(GarbageIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.HamburgerMenu:
            return react_1.default.createElement(HamburgerMenuIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Help:
            return react_1.default.createElement(HelpIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Hide:
            return react_1.default.createElement(HideIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.HomeGreen:
            return react_1.default.createElement(HomeGreenIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Home:
            return react_1.default.createElement(HomeIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Information:
            return react_1.default.createElement(InformationIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Instagram:
            return react_1.default.createElement(InstagramIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Integration:
            return react_1.default.createElement(IntegrationIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Invoice:
            return react_1.default.createElement(InvoiceIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Lift:
            return react_1.default.createElement(LiftIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.LinkedIn:
            return react_1.default.createElement(LinkedInIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Location:
            return react_1.default.createElement(LocationIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.LocationWhiteBg:
            return react_1.default.createElement(LocationWhiteBgIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Lock:
            return react_1.default.createElement(LockIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Logout:
            return react_1.default.createElement(LogoutIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Measure:
            return react_1.default.createElement(MeasureIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.MissedRed:
            return react_1.default.createElement(MissedRedIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Mix:
            return react_1.default.createElement(MixIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.More:
            return react_1.default.createElement(MoreIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Notification:
            return react_1.default.createElement(NotificationIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Organize:
            return react_1.default.createElement(OrganizeIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Pallet:
            return react_1.default.createElement(PalletIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Pdf:
            return react_1.default.createElement(PdfIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.People:
            return react_1.default.createElement(PeopleIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Phone:
            return react_1.default.createElement(PhoneIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Preferences:
            return react_1.default.createElement(PreferencesIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Route:
            return react_1.default.createElement(RouteIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Search:
            return react_1.default.createElement(SearchIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Show:
            return react_1.default.createElement(ShowIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Sofa:
            return react_1.default.createElement(SofaIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.StatusActive:
            return react_1.default.createElement(StatusActiveIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.StatusDefault:
            return react_1.default.createElement(StatusDefaultIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.StatusMissed:
            return react_1.default.createElement(StatusMissedIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.StatusSuccess:
            return react_1.default.createElement(StatusSuccessIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Suitcase:
            return react_1.default.createElement(SuitcaseIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Suitcase:
            return react_1.default.createElement(SuitcaseIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Telephely:
            return react_1.default.createElement(TelephelyIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Template:
            return react_1.default.createElement(TemplateIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.TikTok:
            return react_1.default.createElement(TikTokIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.TruckBubble:
            return react_1.default.createElement(TruckBubbleIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.TruckGreen:
            return react_1.default.createElement(TruckGreenIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Truck:
            return react_1.default.createElement(TruckIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Upload:
            return react_1.default.createElement(UploadIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.User:
            return react_1.default.createElement(UserIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Web:
            return react_1.default.createElement(WebIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Weight:
            return react_1.default.createElement(WeightIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Youtube:
            return react_1.default.createElement(YoutubeIcon_1.default, { color: `icn-${props.color}`, size: `icn-${props.size}` });
        case IconType_1.default.Google:
            return react_1.default.createElement(GoogleIcon_1.default, { size: `icn-${props.size}` });
        default:
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.default = DefaultIcon;
